import { render, staticRenderFns } from "./BillingTotalsSummary.vue?vue&type=template&id=f88aa918"
import script from "./BillingTotalsSummary.vue?vue&type=script&lang=js"
export * from "./BillingTotalsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports